import { INSTANCE_PROFILE } from '@/config/instanceProfile'
import {
  lightMenuPresetDefaults,
  ROCKET_DARK_SURFACES,
  rocketLightMenuDefaults,
  ROCKET_BRAND_IDENTITY,
  type ThemeConfig,
} from '@/types/theme'

export interface ColorPreset {
  id: string
  name: string
  description: string
  swatch: string[]
  colors: Partial<ThemeConfig>
}

const AGRADA_DARK_DEFAULT: ColorPreset = {
  id: 'dark-default',
  name: 'Dark Default',
  description: 'Tema escuro padrão do sistema',
  swatch: ['#5e6ad2', '#0f1117', '#1a1f2e', '#f5f5f6', '#8a8a95'],
  colors: {
    mode: 'dark' as const,
    brandPrimary: '#5e6ad2',
    brandPrimaryHover: '#7c83db',
    brandPrimaryMuted: 'rgba(94, 106, 210, 0.15)',
    brandSecondary: '#22c55e',
    brandSecondaryHover: '#16a34a',
    fontColorH1: '#f5f5f6',
    fontColorH2: '#e8e8ec',
    fontColorH3: '#d0d0d8',
    fontColorBody: '#b4b4be',
    fontColorMuted: '#8a8a95',
    fontColorLabel: '#62626a',
    bgDark: '#08090a',
    bgMain: '#0c0d0e',
    bgSidebar: '#0a0b0c',
    bgCard: '#141516',
    textPrimary: '#f5f5f6',
    textSecondary: '#b4b4be',
    textMuted: '#8a8a95',
    navActiveColor: '#5e6ad2',
    navActiveMuted: 'rgba(94, 106, 210, 0.16)',
  },
}

const ROCKET_DARK_DEFAULT: ColorPreset = {
  id: 'dark-default',
  name: 'Dark Default',
  description: 'Tema escuro padrão Rocket Search',
  swatch: [
    ROCKET_BRAND_IDENTITY.brandPrimary,
    ROCKET_DARK_SURFACES.bgDark,
    ROCKET_DARK_SURFACES.bgCard,
    ROCKET_DARK_SURFACES.textPrimary,
    ROCKET_DARK_SURFACES.textMuted,
  ],
  colors: {
    mode: 'dark' as const,
    brandPrimary: ROCKET_BRAND_IDENTITY.brandPrimary,
    brandPrimaryHover: ROCKET_BRAND_IDENTITY.brandPrimaryHover,
    brandPrimaryMuted: ROCKET_BRAND_IDENTITY.brandPrimaryMuted,
    brandSecondary: '#22c55e',
    brandSecondaryHover: '#16a34a',
    ...ROCKET_DARK_SURFACES,
    navActiveColor: ROCKET_BRAND_IDENTITY.navActiveColor,
    navActiveMuted: ROCKET_BRAND_IDENTITY.navActiveMuted,
    degradePercent: 0,
  },
}

const AGRADA_LIGHT_DEFAULT: ColorPreset = {
  id: 'light-white',
  name: 'Light White',
  description: 'Menu lavanda + item ativo roxo (protótipo)',
  swatch: ['#987de8', '#ebe5f9', '#ffffff', '#111827', '#64748b'],
  colors: {
    mode: 'light' as const,
    brandSecondary: '#22c55e',
    brandSecondaryHover: '#16a34a',
    fontColorH1: '#09090b',
    fontColorH2: '#18181b',
    fontColorH3: '#27272a',
    fontColorBody: '#3f3f46',
    fontColorMuted: '#52525b',
    fontColorLabel: '#52525b',
    bgDark: '#f0f0f3',
    bgMain: '#f8f8fa',
    bgCard: '#ffffff',
    textHeader: '#09090b',
    textSidebar: '#18181b',
    textPrimary: '#09090b',
    textSecondary: '#18181b',
    textMuted: '#3f3f46',
    ...lightMenuPresetDefaults,
  },
}

const ROCKET_LIGHT_DEFAULT: ColorPreset = {
  id: 'light-white',
  name: 'Light White',
  description: 'Tema claro padrão Rocket Search',
  swatch: [
    ROCKET_BRAND_IDENTITY.brandPrimary,
    rocketLightMenuDefaults.degradeColor,
    '#ffffff',
    '#111827',
    '#64748b',
  ],
  colors: {
    mode: 'light' as const,
    brandSecondary: '#22c55e',
    brandSecondaryHover: '#16a34a',
    fontColorH1: '#09090b',
    fontColorH2: '#18181b',
    fontColorH3: '#27272a',
    fontColorBody: '#3f3f46',
    fontColorMuted: '#52525b',
    fontColorLabel: '#52525b',
    bgDark: '#f0f0f3',
    bgMain: '#f8f8fa',
    bgCard: '#ffffff',
    textHeader: '#09090b',
    textSidebar: '#18181b',
    textPrimary: '#09090b',
    textSecondary: '#18181b',
    textMuted: '#3f3f46',
    ...rocketLightMenuDefaults,
  },
}

export const DARK_DEFAULT_PRESET: ColorPreset =
  INSTANCE_PROFILE === 'rocket' ? ROCKET_DARK_DEFAULT : AGRADA_DARK_DEFAULT

export const LIGHT_DEFAULT_PRESET: ColorPreset =
  INSTANCE_PROFILE === 'rocket' ? ROCKET_LIGHT_DEFAULT : AGRADA_LIGHT_DEFAULT
